import React from 'react';
import PropTypes from 'prop-types';

import './ProjectCell.css';

const ProjectCell = (props) => {
  const { project, blank } = props;
  const {
    image, title, trl,
  } = project;

  const visibility = blank ? 'hidden' : 'visible';
  return (
    <div
      className="project-cell"
      style={{
        visibility,
      }}
    >
      <img src={`${image}-1.jpg`} alt="" />
      <div className="project-overlay">
        <div className="overlay-info">
          <h1>{title}</h1>
          <p>
            TRL
            {trl}
          </p>
        </div>
      </div>
      <div className="project-info">
        <h1>{title}</h1>
        <p>
          TRL
          {trl}
        </p>
      </div>
    </div>
  );
};

ProjectCell.propTypes = {
  project: PropTypes.shape({
    title: PropTypes.string.isRequired,
    trl: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }),
  blank: PropTypes.bool,
};

ProjectCell.defaultProps = {
  project: {
    title: '',
    trl: '',
    image: '',
  },
  blank: false,
};

export default ProjectCell;
